var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography-/-Account",
    fill: "#073C50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,24 L23.9338035,24.0661965 L24,48 L19.3174511,47.9870489 L19.2743517,32.4041595 L3.77325362,47.9056467 L0.0947424041,44.2271354 L15.5962285,28.7256494 L0.012951072,28.6825489 L0,24 Z M23.9411255,0 L28.6236744,0.012951072 L28.6667738,15.5958405 L44.1678719,0.0943533495 L47.8463831,3.77286457 L32.344897,19.2743506 L47.9281744,19.3174511 L47.9411255,24 L24.007322,23.9338035 L23.9411255,0 Z",
    id: "Account"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.3ebd4791db019cd32893b3c62fe84f6d.svg";
export { ForwardRef as ReactComponent };